import * as swcHelpers from '@swc/helpers';
import isEmpty from 'lodash/isEmpty';

/** @deprecated use the new GQL hook use-opt-ins.ts */ const createOptInsUpdate = (optIns = {})=>{
    if (isEmpty(optIns)) {
        return undefined;
    }
    var ref, ref1;
    return Object.keys(optIns).reduce((m, optInName)=>{
        var ref3, ref2;
        return swcHelpers.objectSpread({}, m, {
            [optInName]: {
                value: (ref = (ref3 = optIns[optInName]) === null || ref3 === void 0 ? void 0 : ref3.checked) !== null && ref !== void 0 ? ref : false,
                uiType: 'checkbox',
                literalText: (ref1 = (ref2 = optIns[optInName]) === null || ref2 === void 0 ? void 0 : ref2.label) !== null && ref1 !== void 0 ? ref1 : ''
            }
        });
    }, {});
};

export { createOptInsUpdate };
//# sourceMappingURL=create-opt-in-updates.js.map
